// extracted by mini-css-extract-plugin
module.exports = {"overrideWidth":"UserPerformance_overrideWidth__1T1Ce"};